module.exports = __webpack_public_path__ + "static/media/12_Vivian Choi (International)-min.5297ff02.jpg";